import { useGetAllowedTargeting } from '@apis/allowedTargeting';
import { groupBy } from 'lodash';
import { useMemo } from 'react';
import {
  UseInventoryListViewIncludedParams,
  UseInventoryListViewIncludedReturn,
} from '../types';

export const useInventoryListViewIncluded = ({
  data,
  isEmpty,
}: UseInventoryListViewIncludedParams): UseInventoryListViewIncludedReturn => {
  const { data: allowedTargeting } = useGetAllowedTargeting();
  const isAllIncluded = useMemo(() => {
    const groupedSelected = groupBy(data, 'type');
    const groupedResponse = groupBy(allowedTargeting, 'type');

    const includedDevices = groupedSelected.DEVICE ?? [];
    const includedOs = groupedSelected.OS ?? [];

    return {
      device: {
        all:
          isEmpty ||
          includedDevices.length === groupedResponse.DEVICE?.length,
        data: includedDevices,
      },
      os: {
        all: isEmpty || includedOs.length === groupedResponse.OS?.length,
        data: includedOs,
      },
    };
  }, [data, allowedTargeting, isEmpty]);

  return isAllIncluded;
};
